export default "__VITE_ASSET__291242d9__"